import axios from 'axios';

const handlesToTiles = async (handles) => {

  let productsData = await Promise.all(handles.map(h => {
    return axios.get(`${ window.location.origin }/products/${ h }?view=nolayout.tile`).then(res => res.data).catch(err => {
      console.error(err);
      return null;
    });
  }));

  // console.log(productsData);

  // Note: returning an array of HTML instead of flat HTML so tiles can be counted
  // .join('')
  return productsData.filter(data => data);
}

export default handlesToTiles;